<template>
  <el-header class="header">
    <div class="theme">VANS 核销</div>
    <div class="column">
      <div><i class="el-icon-user-solid"></i>{{userName}}</div>
      <div class="loginout" @click="handleLogout">退出</div>
    </div>
  </el-header>
</template>

<script>
import $ from '@/assets/js/$axios'
import urls from '@/assets/js/urls.js'
export default {
  data () {
    return {}
  },
  computed: {
    userName () {
      return localStorage.getItem('userName');
    }
  },
  methods: {
    handleLogout () {
      const that = this;
      $.Axios('get',urls.logout, {} ,(res)=>{
        if (res.errcode == 0) {
          localStorage.setItem('userName', '');
          that.$router.push({
            path: "/login",
            query: {}
          })
          that.$message({
            type: 'success',
            message: '退出登陆!',
            onClose: function() {
            }
          });
        } else {
          that.$message({
            type: 'info',
            message: res.msg || res.errmsg
          });
        }
      })
    }
  }
}
</script>


<style lang="less" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .column {
      width: 142px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .loginout {
        cursor: pointer;
      }
    }
  }
</style>